import { useCallback, useContext } from 'react';

import { ChatCtx } from '@r1-frontend/entities/Chat/ChatContext';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

export const useChat = () => {
    const { chatInstance } = useContext(ChatCtx);

    const open = useCallback((message?: string) => {
        if (chatInstance) {
            dataLayerPush({ event: 'online_chat', category: 'user', action: 'launched online chat' });
            return chatInstance.open.call(chatInstance, message);
        }
    }, [chatInstance]);

    const close = useCallback(() => {
        if (chatInstance) {
            return chatInstance.close.call(chatInstance);
        }
    }, [chatInstance]);

    return { open, close };
};
